import { DueDateOffsetField, PercentageField, SelectField } from 'form';
import { Grid, Typography } from 'ui';

import { buyerPaymentEventOptions, paymentMethodOptions, sellerPaymentEventOptions } from '../../utils';

export const PaymentSection = () => {
  return (
    <>
      <Typography variant="h5">Payment</Typography>
      <Grid item xs={12}>
        <SelectField
          fullWidth
          label="Purchaser Payment Method"
          name="purchaser_payment_method"
          options={paymentMethodOptions}
        />
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <PercentageField label="Seller Deposit Percentage" name="seller_deposit_percentage" />
        </Grid>
        <Grid item xs={12} md={4}>
          <SelectField
            fullWidth
            label="Seller Payment Event"
            name="seller_payment_event"
            options={sellerPaymentEventOptions}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <DueDateOffsetField
            required
            label="Seller Due Date Offset"
            name="seller_due_date_offset"
            offsetFieldName="seller_due_date_offset_direction"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <PercentageField label="Purchaser Deposit Percentage" name="buyer_deposit_percentage" />
        </Grid>
        <Grid item xs={12} md={4}>
          <SelectField
            fullWidth
            label="Purchaser Payment Event"
            name="buyer_payment_event"
            options={buyerPaymentEventOptions}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <DueDateOffsetField
            label="Purchaser Due Date Offset"
            name="buyer_due_date_offset"
            offsetFieldName="buyer_due_date_offset_direction"
          />
        </Grid>
      </Grid>
    </>
  );
};
